export function createRoute(path, name, component, otherProps) {
  return {
    path,
    name,
    component,
    ...otherProps,
  };
}
